import React from 'react';

import { flagStyles } from '../settings';

const SvgOM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4080px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgOM;
